import React, { useCallback, useEffect, useState } from 'react'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { action_fetch_gift_info, action_fetch_order_prompt, action_fetch_collect_products, action_fetch_filter_sorters, action_add_collect_products, action_fetch_cart, action_fetch_add_on_filter, action_init_add_on_items, action_append_add_on_items, setCollectProducts, setCollectProductsFinished, action_init_cart, action_collect_products_sort } from '../../../../../store/actions/pages/cart'
import { useQuery } from '../../../../hooks/common'
import { useSensors } from '../../../../hooks/sensor'
import NormalPage from '../../layout/normal-page'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { getSensorsUrl } from '../../../../utils/sensor'
import { FormattedMessage, useIntl } from 'react-intl'
import { GiftItem, GiftSkeleton } from './fragments/gift-item'
import { GiftsSwiper } from './fragments/gifts-swiper'
import { deleteItemNew, fetchCollectionList, removeAddOnItem } from '../../../../../api'
import FilterProducts from './fragments/filter-products'
import { FilterSortBox } from './fragments/filter-sorts'
import { FilterBottomButton } from './fragments/filter-bottom-button'
import NormalConfirm from '../../../../components/alert/confirm'
import ProductEditor from '../../../listing/components/cart/product-editor'
import { useMemo } from 'react'
import FilterQuickSelect from './fragments/filter-quick-select'
import { CartCountIcon } from './components/cart-count-icon'
import Loading from '../../../../components/loading/op-loading'
import Cache from '../../../../../utils/cache'
import ProgressLine from './fragments/progress-line'
import { action_fetch_cart_count } from '../../../../../store/actions/global'
import Affix from '../../../../components/affix'
import { TOOGLE_UI_CONFIRM } from '../../../../../store/actions/ui'
import useCart from '../bag/hooks/cart'
import Toast from '../../../../components/toast'

const FreeGiftPickBox = props => {
    useStyles(classes)
	const {giftInfo, setViewingItem, setShowEditor, giftProductList = [], intl, confirmBefore, sensors, history} = props
	const [firstLoading, setFirstLoading] = useState(true)

	const [giftSkip, setGiftSkip] = useState(0)
	const [giftLoading, setGiftLoading] = useState(true)
	const [giftLabel, setGiftLabel] = useState('')
	const [gifts, setGifts] = useState([])

	const giftCollectionId = useMemo(() => {
        if(giftInfo?.deepLink?.params?.[2]){
            let id = giftInfo?.deepLink?.params?.[2]?.split("giftCollectionId=")?.[1]
            if(id?.indexOf("&") != -1){
                id = id?.split("&")[0]
            }
            return id
        } else {
            return null
        }
    }, [giftInfo?.deepLink?.params])

	useEffect(() => {
		if(!giftLoading){
			setFirstLoading(false)
		}
	}, [giftLoading])

	useEffect(() => {
		if(giftInfo?.giftWarnMsg){
			const {giftWarnMsg} = giftInfo
			setGiftLabel(giftWarnMsg)
		}
	}, [giftInfo?.giftWarnMsg])

	useEffect(() => {
		if(gifts?.length == 0 && giftCollectionId){
			getGifts(giftCollectionId)
		}
	}, [gifts, giftCollectionId])

	const getGifts = (id, limit = 20) => {
		fetchCollectionList({collectionId:id}, {skip: giftSkip, limit:limit, onlyProducts:true}).then(res => {
			if(res && res.code == 200 && res.result){
				setGifts(res.result)
				setGiftSkip(giftSkip + limit)
			}
			setGiftLoading(false)
		}).catch(err => {
			alert(err.result || err)
			setGiftLoading(false)
		})
	}

	const onSelect = (vairant, product, index) => {
        // console.log(vairant, product, index)
		setViewingItem({
			variantId: vairant.id,
			quantity: 1,
			type: 'filter_products',
			position: index+1,
			getGiftWay: 'PROMOTIONAL_ACTIVITY',

			isGift: 'PROMOTIONAL_ACTIVITY',
			sensors:{
				is_gift: true,
			},
			color: vairant?.color,
			productId: product.id,
		})
		setShowEditor(true)
	}

	return (
		<div className={classes.FreeGiftPickBox}>
			<div className={classes.PickLine}>
				<span className={classes.PickLabel} dangerouslySetInnerHTML={{__html:giftLabel}}></span>
				<span className={classes.PickIcon}
					  onClick={() => {
						if (window.GeekoSensors) {
							window.GeekoSensors.Track('FreeGiftClick', {
								page_title: '凑单页',
							})
						}
						Cache.set("___tfig_",true)
						history.push(getSensorsUrl('/cart/free-gifts',sensors))
						return
					  }}>
					<span>{ giftProductList.length > 0 ? intl.formatMessage({id: 'repick', defaultMessage: 'Repick'}): intl.formatMessage({id: 'pick'})} {'>'}</span>
				</span>
			</div>
			{
			    giftProductList.length == 0 ?
				<div className={classes.ProductLine}>
					{
						giftLoading && firstLoading ?
						<React.Fragment>
							<div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
								{
									[1,2,3,4,5].map((item, index) => {
										return <GiftSkeleton key={new Date().getTime()}/>
									})
								}
							</div>
						</React.Fragment>:
						<GiftsSwiper
							// onSelect={onSelect}
							products={gifts}
							iconOnImage={true}
							isGift={true}
							sensors={sensors}
							giftInfo={giftInfo} 
							product_type={''}
							/>
					}
				</div>:
				<React.Fragment>
					<div className={classes.PickedGiftItem}>
						<GiftItem
							item={giftProductList[0]}
							itemEdit={(item) => {
								if (window.GeekoSensors) {
									window.GeekoSensors.Track('CartAction', {
										action: "ClickColor"
									})
								}
								setViewingItem({
									productId: item.productId,
									variantId: item.variantId,
									quantity: 1,
									type: 'filter_products',
									position: 1,
									isGift: 'PROMOTIONAL_ACTIVITY',
									getGiftWay: 'PROMOTIONAL_ACTIVITY',
									sensors:{
										is_gift: true,
									},
									color: item?.color,
								})
								setShowEditor(true)
							}}
							itemDelete={(item) => {
								confirmBefore(item)
							}}
							isInCart={true}
							/>
					</div>
				</React.Fragment>
			}
		</div>
	)
}

const CollectOrder = props => {
	useStyles(classes)
    const pageCart = useSelector(state => state.pageCart)
	const global = useSelector(state => state.global)
    const dispatch = useDispatch()
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()
    const Intl = useIntl()
    const {
        cart,
        collectProducts,
        collectSkip,
        collectLoading,
        collectFinished,
        collectFilter,
        cartCount,
        giftInfo,
		filerPromptMsg,
		filterSorts,
    } = pageCart || {}

	const {countCart} = global || {}
    // type为0免邮 为1优惠券 没有为礼物 2 为addon凑单
    const type = params.type || query?.type

    const [sensors, setSensors] = useState(useSensors())

	const [showSort, setShowSort] = useState(false)
	const [showCategory, setShowCategory] = useState(false)
	const [categoryReset, setCategoryReset] = useState(false)
	const [showPrice, setShowPrice] = useState(false)
	const [priceReset, setPriceReset] = useState(false)
	const [selectHead, setSelectHead] = useState(0)
	const [sorters, setSorters] = useState(null)
	const [sort, setSort] = useState(null)
	const [selectedSort, setSelectedSort] = useState(null)
	const [selectedFilterItems, setSelectedFilterItems] = useState(null)
	const [filterItems, setFilterItems] = useState(null)
	const [priceCurrency, setPriceCurrency] = useState(null)
	const [priceUnit, setPriceUnit] = useState(null)
	const [startPrice, setStartPrice] = useState(0)
	const [endPrice, setEndPrice] = useState(0)
	const [defaultData, setDefaultData] = useState(null)

	const [viewingItem, setViewingItem] = useState(null)
	const [showEditor, setShowEditor] = useState(false)

	const [quickPriceList, setQuickPriceList] = useState(null)
	const [quickPriceSelect, setQuickPriceSelect] = useState(null)
	const [quickPriceSelectEnLabel, setQuickPriceSelectEnLabel] = useState(null)
	const [quickPriceSelectLabel, setQuickPriceSelectLabel] = useState(null)

	const [pageRefreshing, setPageFreshing] = useState(false)

	const isShipping = type === 0 || type === '0' || type === 3 || type === '3'
	const isCoupon = type === 1 || type === '1'
	const isAddOn = type === 2 || type === '2'
	const isGiftPage = !isShipping && !isCoupon && !isAddOn

	const [shouldShowProgress, setShouldShowProgress] = useState(false)

	const differenceArg = useMemo(() => {
		let difference = !isGiftPage ?
						filerPromptMsg?.difference?.amount || 0:
						giftInfo?.difference?.amount || 0
		let differenceItems = !isGiftPage ?
							  filerPromptMsg?.differenceItems || 0: 0
		return {difference, differenceItems}
	}, [giftInfo, type, filerPromptMsg])

	const {
        removeItemsHandle,
    } = useCart()

    useEffect(async () => {
		try {
			if (window.GeekoSensors) {
				window.GeekoSensors.Quick('autoTrackSinglePage', {
					page_title: '凑单页'
				})
				window.pageTitle = '凑单页'
			}
		} catch (error) {

		}
		if(window.scrollTo){
			window.scrollTo({
				top: 0,
			})
		}
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {

		}

		if(!collectProducts){
			await initData()
		} else {
			if(Cache.get("___tfig_")){
				Cache.remove("___tfig_")
			} else {
				setPageFreshing(true)
				await initData()
				setPageFreshing(false)
			}
		}

		updateCartCount()

		if(!filterSorts){
			const res = isAddOn ?
				await dispatch(action_fetch_add_on_filter()):
				await dispatch(action_fetch_filter_sorters())
		}
    }, [])

	useEffect(() => {
		if(filterSorts){
			setSorters(filterSorts?.sorters)
			setSort(filterSorts?.sorters?.[0]?.value)
			setSelectedSort(filterSorts?.sorters?.[0])
			setFilterItems(filterSorts?.categories)
			setPriceCurrency(filterSorts?.currency)
			setPriceUnit(filterSorts?.currencyUnit)
			setEndPrice(filterSorts?.endPrice)
			setDefaultData(filterSorts)
			setQuickPriceList(filterSorts?.priceSelections || null)
			setQuickPriceSelectLabel(filterSorts?.defaultSelectionLabel || null)
		}
	}, [filterSorts])

	useEffect(() => {
		let body = document.getElementsByTagName('body')[0]
		if(showCategory || showPrice || showSort){
			body.style.overflow = 'hidden'
		} else {
			body.style.overflow = 'auto'
		}

	}, [showSort, showCategory, showPrice])

	useEffect(() => {
		if(filerPromptMsg?.progress && !pageRefreshing && !isGiftPage && !isAddOn){
			setShouldShowProgress(true)
		} else {
			setShouldShowProgress(false)
		}
	}, [filerPromptMsg?.progress, pageRefreshing, isGiftPage])

	const deleteItemHandle = useCallback((item, callBack) => {
        dispatch({
            type: TOOGLE_UI_CONFIRM,
            payload: {
                show: true,
                options: {
                    onCancel: () => {
                        dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                    },
                    onConfirm: async () => {
                        dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                        await removeAddOnItem(item?.id)
						// 更新
						await dispatch(action_fetch_order_prompt(type))
						callBack && callBack?.()
                    },
                    okText: <FormattedMessage id="confirm" defaultMessage="Confirm" />,
                    cancelText: <FormattedMessage id="cancel" defaultMessage="Cancel" />,
                    content: <FormattedMessage id="sure_delete_item" defaultMessage="Are you sure you want to delete this product?" />
                }
            }
        })
    }, [])

    const onScroll = () => {
		onFilter({...collectFilter},true)
    }

	const initData = () => {
		if(isAddOn){
			initAddOnData()
		} else {
			initCouponShippingData()
		}
	}

	const initAddOnData = async () => {
		let data = {
			startPrice: 0,
			endPrice: 0,
			sorter: 0,
			productCategoryIds:[]
		}
		let difference = 0
		let differenceItems = 0
		const addOnFilter = store.dispatch(action_fetch_add_on_filter(type))
		const prompt = store.dispatch(action_fetch_order_prompt(type))
		await Promise.all([addOnFilter, prompt]).then(res => {
			difference = type === 0 || type === '0' || type === 1 || type === '1' || type === 3 || type === '3' ? res?.[0]?.difference?.amount || 0: 0
			differenceItems = 0
			if(res?.[1]?.buyCount >= res?.[1]?.maxCount){
				Toast(Intl.formatMessage({id:'addon_reach_limit',defaultMessage:"You've reached the limit for selected add-on items.Click \"Selected\" to undo your selection."}))
			}
		}).then(res1 => {
			store.dispatch(action_init_add_on_items(data, {type: type, skip:0, difference, differenceItems}))
		})
	}

	const initCouponShippingData = async () => {
		const type = params.type || query?.type

		let data = {
			startPrice: 0,
			endPrice: 0,
			sorter: 0,
			productCategoryIds:[],
		}
		let difference = 0
		let differenceItems = 0
		let progressCouponId = ''
		const giftInfo = store.dispatch(action_fetch_gift_info())
		const prompt = store.dispatch(action_fetch_order_prompt(type, ))

		await Promise.all([giftInfo, prompt]).then(res => {
			difference = type === 0 || type === '0' || type === 1 || type === '1' || type === 3 || type === '3' ? res?.[1]?.difference?.amount || 0: res?.[0]?.difference?.amount || 0
			differenceItems = type === 0 || type === '0' || type === 1 || type === '1' || type === 3 || type === '3' ? res?.[1]?.differenceItems: 0
			progressCouponId = res[1]?.progressCouponId
		}).then(res1 => {
			store.dispatch(action_fetch_collect_products({...data, progressCouponId}, {type, skip:0, difference, differenceItems, }))
		})
	}

    const updateCartCount = async () => {
        await dispatch(action_fetch_cart_count())
    }

    const updateGiftInfo = async () => {
        await dispatch(action_fetch_gift_info())
    }

    const confirmBefore = (item) => {
		NormalConfirm(
			'',
			Intl.formatMessage({id: 'sure_delete_item', defaultMessage:'Are you sure you want to delete this product?'}),
			{
				onConfirm: () => deleteConfirm(item),
				cancelText: Intl.formatMessage({id:'cancel', defaultMessage: 'Cancel'}),
				confirmText: Intl.formatMessage({id:'confirm', defaultMessage: 'Confirm'})
			})
    }

	const deleteConfirm = (item) => {
		deleteItemNew(item?.id ).then(res => {
			if(res?.code == 200 && res?.result){
				updateGiftInfo()
				dispatch(action_fetch_cart(res?.result))
			}
		}).catch(err => {
			console.log("礼物删除报错", err)
		})
	}

	const selectSort = (sorter) => {
		setSort(sorter.value)
		setShowSort(false)
		setSelectedSort(sorter)
		onFilter({...collectFilter, sorter: sorter.value})
	}

	const categoryResetFunc = () => {
		const noSelectItems = filterItems.map(f => {f.selected = false; return f})
		setFilterItems(noSelectItems)
		setSelectedFilterItems(null)
		setCategoryReset(true)
		onFilter({
			...collectFilter,
			productCategoryIds: []
		})
	}

	const categoryDone = () => {
		setShowCategory(false)
		setShowPrice(false)
		setShowSort(false)
		if(!categoryReset){
			onFilter({
				...collectFilter,
				productCategoryIds: selectedFilterItems ? selectedFilterItems.map(s => s.value): []
			})
		}
	}

	const priceResetFunc = () => {
		setEndPrice(defaultData.endPrice)
		setStartPrice(0)
		setPriceReset(true)
		setQuickPriceSelect(null)
		setQuickPriceSelectEnLabel('')
		onFilter({
			...collectFilter,
			endPrice: defaultData.endPrice,
			startPrice: 0,
		})
	}

	const priceDone = () => {
		setShowCategory(false)
		setShowPrice(false)
		setShowSort(false)
		setQuickPriceSelect(null)
		if(!priceReset){
			onFilter({
				...collectFilter,
				startPrice: Number(startPrice),
				endPrice: Number(endPrice),
			})
		}
	}

	const priceFilterChange = (values) => {
		setStartPrice(values[0])
		setEndPrice(values[1])
		setPriceReset(false)
	}

	const quickPriceChange = (item) => {
		if(window.GeekoSensors){
			window.GeekoSensors.Track("Price_Tag",{
				price_tag: item == 'ship' ? 'Free Shipping': item.enLabel
			})
		}
		if(collectLoading)return
		if(item == 'ship'){
			setQuickPriceSelect('ship')
			setQuickPriceSelectEnLabel('Free Shipping')
			setEndPrice(defaultData ? defaultData.endPrice: 0)
			let params = {
				productCategoryIds: collectFilter ? collectFilter.productCategoryIds : [],
				sorter: collectFilter ? collectFilter.sorter: "0",
				startPrice:0,
				endPrice:0
			}
			onFilter({...params})
		} else {
			setEndPrice(item.end)
			setStartPrice(item.start || 0)
			setQuickPriceSelect(item.value)
			setQuickPriceSelectEnLabel(item.enLabel)
			onFilter({...collectFilter, endPrice: item.end, startPrice: item.start || 0})
		}
	}

	const removeSelection = (selection) => {
		const selectList = [...selectedFilterItems]
		const selectRes = selectList.filter(s => s.value != selection.value)
		const allList = [...filterItems]
		let res = allList.map(item => {
			if(selection.value == item.value){
				return {...item, selected: false}
			} else {
				return {...item}
			}
		})
		setSelectedFilterItems([...selectRes])
		setFilterItems([...res])
		setCategoryReset(false)
	}

	const selectionClick = (selection) => {
		const list = []
		let res = filterItems.map(item => {
					if(selection.value == item.value){
						if(item.selected){
							return {...item, selected: false}
						} else {
							list.push(item)
							return {...item, selected: true}
						}
					} else {
						if(item.selected){
							list.push(item)
						}
						return {...item}
					}
				})
		setFilterItems([...res])
		setSelectedFilterItems(list)
		setCategoryReset(false)
	}

	const onClose = () => {
		history.go(-1)
	}

	const beforeChangeData = () => {}

	const onFilter = async (filterArg, isScroll) => {
		let difference = differenceArg?.difference
		let differenceItems = differenceArg?.differenceItems
		let skip = isScroll ? collectSkip: 0
		let res = null
		if(isScroll){
			!isAddOn ?
			res = await dispatch(action_add_collect_products(filterArg, {type, skip: skip, difference, differenceItems})):
			res = await dispatch(action_append_add_on_items(filterArg, {type:2, skip: skip, difference, differenceItems}))
		} else {
			!isAddOn?
			res = await dispatch(action_fetch_collect_products(filterArg, {type, skip: 0, difference, differenceItems})):
			res = await dispatch(action_init_add_on_items(filterArg, {type:2, skip: 0, difference, differenceItems}))
		}
		if(res){
			if(window.GeekoSensors){
				try{
					window.GeekoSensors.Track('Filter', {
						'filter': (filterItems || []).map(item => {
							const fieldName = item.fieldName
							const selectionStr = (item.selections||[]).map(s => s.value).join(',')
							return `${fieldName}:${selectionStr}`
						}).join(';'),
						'sort': sort,
						'startPrice':filterArg.startPrice,
						'endPrice': filterArg.endPrice,
						'skip': res?.skip,
						'limit': 20,
						'resourcepage_title': 'shoppingcart'
					})
				}catch(e){
					console.error(e)
				}
			}
		}
	}

	const filterInfo = useMemo(() => {
		let sorter = selectedSort?.enLabel ? 'sort:' + selectedSort?.enLabel: 'sort:Recommend'
		let tag = selectedFilterItems?.length > 0 ? selectedFilterItems.map(s => s.enLabel).join(','): ''
		let price = `[${startPrice},${endPrice}]`
		return`${sorter? sorter: ''}${tag?','+tag:''}${price ? ','+price: ''}`
	}, [selectedSort,selectedFilterItems,startPrice,endPrice])

	const cartCountNum = useMemo(() => {
		// console.log("cartCount: ", cartCount, "countCart: ", countCart)
		if(!cartCount && !countCart){
			return 0
		} else {
			return countCart
		}
	}, [cartCount, countCart])

	const pageTitle = useMemo(() => {
		let title = ''
		switch(type){
			case 0:
			case '0':
			case 1:
			case '1':
			case 3:
			case '3':
				break;
			case 2:
			case '2':
				title = <FormattedMessage id="add_on_items" defaultMessage="Add-on Items" />
				break
			default:
				// 礼物
				title = <FormattedMessage id="free_gift" defaultMessage="Free gifts" />
				break
		}
		return title
	}, [type])

    return <div>
		{
            pageRefreshing && <Loading />
        }
        <NormalPage
            onBack={() => { history.goBack() }}
            title={pageTitle}
            extra={<CartCountIcon cartCount={cartCountNum}/>}
            hideSecure={true}
            >

			{
				shouldShowProgress &&
				<ProgressLine
					type={isShipping? 'shipping': 'coupon'}
					promoteMsg={filerPromptMsg}
					/>
			}

			{
				isGiftPage ?
				<React.Fragment>
					<FreeGiftPickBox
						intl={Intl}
						giftInfo={giftInfo}
						setViewingItem={setViewingItem}
						setShowEditor={setShowEditor}
						giftProductList={giftInfo?.gifts}
						confirmBefore={confirmBefore}
						sensors={sensors}
						history={history}
						/>

					<div className={classes.RecommendTxt}>
						<FormattedMessage id={'recommend_add_item'} defaultMessage={'Recommend Add-On Items'}/>
					</div>
				</React.Fragment>:
				<React.Fragment></React.Fragment>
			}

			{
				isAddOn && filerPromptMsg?.msg ?
				<React.Fragment>
					<Affix offsetTop={44}>
						<div className={classes.AddOnTip}>
							{filerPromptMsg?.msg}
							{/* <FormattedMessage id={'enjoy_discount_add_items'} defaultMessage={'Enjoy discounts only if you add items from this list to your cart.'}/> */}
						</div>
					</Affix>
				</React.Fragment>:
				<React.Fragment></React.Fragment>
			}

			<FilterSortBox
				selectHead={selectHead}
				setSelectHead={v => setSelectHead(v)}
				beforeChangeData={() => beforeChangeData()}
				sorters={sorters}
				sort={sort}
				selectSort={selectSort}
				selectedFilterItems={selectedFilterItems}
				filterItems={filterItems}
				categoryReset={categoryResetFunc}
				categoryDone={categoryDone}
				priceCurrency={priceCurrency}
				priceUnit={priceUnit}
				priceReset={priceResetFunc}
				priceDone={priceDone}
				startPrice={startPrice}
				endPrice={endPrice}
				defaultData={defaultData}
				priceFilterChange={priceFilterChange}
				removeSelection={removeSelection}
				selectionClick={selectionClick}
				showSort={showSort}
				setShowSort={setShowSort}
				showCategory={showCategory}
				setShowCategory={setShowCategory}
				showPrice={showPrice}
				setShowPrice={setShowPrice}
				/>

			{
			    quickPriceList?.length > 0 ?
				<FilterQuickSelect
					isShipping={isShipping}
					changeSelect={quickPriceChange}
					intl={Intl}
					selected={quickPriceSelect}
					data={quickPriceList}
					defaultSelectionLabel={quickPriceSelectLabel}
					/>:
				<React.Fragment></React.Fragment>
			}

            <FilterProducts
                sensors={{
					...sensors,
					filter: filterInfo,
					title: 'cart',
					price_tag: quickPriceSelectEnLabel
				}}
                products={collectProducts}
                request={onScroll}
                loading={collectLoading}
                finished={collectFinished}
				isAddOn={isAddOn}
				deleteItemHandle={async (item, callBack) => {
					deleteItemHandle(item, callBack)
				}}
				afterAddToCart={async (product) => {
					await dispatch(action_collect_products_sort(product, 0))
					// 更新
					const res = await dispatch(action_fetch_order_prompt(type))
					// 如果 addon 超过 5 个返回上一级
					if(res?.buyCount >= res?.maxCount){
						Toast(Intl.formatMessage({id:'addon_reach_limit',defaultMessage:"You've reached the limit for selected add-on items.Click \"Selected\" to undo your selection."}))
						setTimeout(() => {
							window.history.go(-1)
						}, 5000)
					} else {
						Toast(Intl.formatMessage({ id: 'add_successful', defaultMessage: 'Add Successful' }));
					}
				}}
				beforeAddToCart={(callBack) => {
					if(filerPromptMsg?.buyCount >= filerPromptMsg?.maxCount){
						Toast(Intl.formatMessage({id:'addon_reach_limit',defaultMessage:"You've reached the limit for selected add-on items.Click \"Selected\" to undo your selection."}))
					} else {
						callBack && callBack?.()
					}
				}}
                />
			{
				!isGiftPage && !isAddOn ?
				<FilterBottomButton
					promotMsg={filerPromptMsg}
					cartCount={cartCountNum}
					cart={cart}
					type={type}
					onClose={() => {
						onClose()
					}}
					/>:
				<React.Fragment></React.Fragment>
			}

        </NormalPage>

		<ProductEditor
			isGift={viewingItem?.isGift}
			giftInfo={giftInfo}
			sensors={viewingItem?.sensors ? {...sensors, ...viewingItem?.sensors}: sensors}
			showEditor={showEditor}
			onClose={() =>{
				setShowEditor(false)
				// history.goBack()
			}}
			productId={viewingItem?.productId}
			color={viewingItem?.color}
			/>
    </div>
}

CollectOrder.fetchData = async (store, params, search, headers, flag = false) => {
	// await store.dispatch(action_init_cart(headers))
}

export default CollectOrder